import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import Devices from "@/containers/devices";
import { getTimehash } from "@gc-npm/utils.page.get-time-hash";
import Header from "@gc-npm/components.header";
import getPageProps from "@gc-npm/adabyron.page.get-props";
import Footer from "@gc-npm/components.footer";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import { actions as devicesListActions } from "@/reducers/devices-list";
import { actions as headerActions } from "@gc-npm/reducers.header-reducer";
import MetaData from "@gc-npm/core.meta-data";
import { wrapper } from "@/store";
import SuperCategoryRail from "@/component/SuperCategoryRail";
import FakeDevices from "@/component/fakes/devices";
//import { getAllItem } from "@gc-npm/adabyron.catalogue.get-all-item";
import { getAllItem } from "@/adabyron/timer-wrappers/get-all-item";
import { getDevicesListBreadcrumbsProps } from "@/utils/headerUtils";
//import { getAllItem  } from "@/sagas/saga-temp/get-all-item";
//import { getByAlias } from "@gc-npm/adabyron.orion.get-by-alias";
//import { getByName } from "@gc-npm/adabyron.custo.get-by-name";
import { getByName } from "@/adabyron/timer-wrappers/get-by-name";
//import { getByAlias } from "@/adabyron/orion/get-by-alias";
import { findOutEnvByEnvName } from "@gc-npm/utils.enums.environment";
import { getSecondaryMenu } from "@gc-npm/adabyron.header.get-secondary-menu";
import useMyProducts from "@/utils/hooks/use-my-products";
import { actions as pageInfoActions } from "@/reducers/page-info";
import { END } from "redux-saga";
import CmsBlock from '@gc-npm/components.cms/cms-block';
import CmsPageIntro from "@gc-npm/components.cms-block.page-intro";
import BottomSEO from "@/containers/bottom-seo";
import { getBuildCachedPromise } from "@/utils/build-promise-cache";
import { getBuildCachedJwtCloudRun } from "@/utils/build-promise-cache/get-jwt-cloud-run";
import apiFetch from "@gc-npm/astro/astro-fetch";
import { loadCategoryLinkLabels, mergeCategoryLinkLabels } from "@/utils/normalizers/category-link-labels";
import { normalizeRichTextLinks } from "@/utils/normalizers/rich-text-links";
import TextInfo, {
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
  TEXT_KIND,
  TEXT_HEADING_LEVEL,
} from "@gc-npm/components.text";

const NeonBanner = dynamic(() => import("@gc-npm/components.neon-banner"));
const SuperBanner = dynamic(() => import("@gc-npm/components.superbanner"));

const Dispositivos = ({
  seoInfo,
  hash,
  headerProps,
  breadcrumbsProps,
  bannerInfo,
  superBannerInfo,
  id,
  orionInfo,
  orionAlias,
  footerProps,
  superCategories
}) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { hasToShowR2RRenovationOffers } = useSelector(
    (state) => state.devicesList
  );
  const [breadcrumbForced, setBreadcrumbForced] = useState(undefined);
  const [headerPropsState, setHeaderPropsState] = useState(headerProps);
  const { context, logged } = useSelector((state) => state.main);
  useMyProducts();
  const { breadcrumbText } = useSelector((state) => state.pageInfo);

  const {
    getMyProductLoaded,
    creditLimitLoaded,
    getMyProductFailure,
    totalPvp
  } = useSelector((state) => state.getMyProducts);
  const { query } = router;
  const { offerCategory, segment } = query;

  useEffect(() => {
    setupHeaderProps();
  }, [query, context]);

  const setupHeaderProps = async () => {
    if (offerCategory !== undefined || segment === "au") {
      const breadcrumbsProps = getDevicesListBreadcrumbsProps({
        id,
        query,
        segment,
        breadcrumbText,
      });
      setBreadcrumbForced(breadcrumbsProps);
    }
    let newHeaderProps = headerProps;
    if (segment === "au") {
      const { secondaryMenuProps } = await getSecondaryMenu({
        context,
        segment,
        location: "--moviles",
      });
      newHeaderProps = {
        ...headerProps,
        secondaryMenu: {
          selectedLink: "moviles",
          items: secondaryMenuProps,
        },
        forceSelect: "Autónomos",
        hideNavMenu: true,
      };
    }
    setHeaderPropsState(newHeaderProps);
    dispatch(headerActions.setupHeaderProps(newHeaderProps));
  };

  useEffect(() => {
    //Caso logado o con info forzada
    if (
      (context?.userType !== "" || offerCategory) &&
      getMyProductLoaded &&
      creditLimitLoaded &&
      query &&
      Object.keys(query).length > 0 &&
      router.isReady
    ) {
      query.firstLoad = true;
      dispatch(
        devicesListActions.initGetDevicesList({
          id,
          queryParams: query,
        })
      );
    }
  }, [
    context?.userType,
    query,
    getMyProductLoaded,
    router,
    creditLimitLoaded,
    offerCategory
  ]);

  useEffect(() => {
    if (logged !== 0) {
      let clValue = "";
      //No logado
      if (logged === "") {
        clValue = "no-cliente";
      } else if (logged === "Telco" && creditLimitLoaded) {
        if (totalPvp) {
          clValue = totalPvp;
        } else {
          clValue = "desconocido";
        }
      }
      if (clValue) {
        gtag('event', 'cms_component', {
          'component_name': 'devicesList',
          'component_content': `creditLimit:${clValue}`,
          'component_variation': 'all',
          'component_product': 'mobile',
          'event_type': 'print-success'
        });
      }
    }
  }, [logged, creditLimitLoaded]);

  useEffect(() => {
    //Caso no logado o con error del mis productos
    if (
      ((context?.userType === "" && logged !== 0 && !offerCategory) || getMyProductFailure) &&
      router.isReady
    ) {

      query.firstLoad = true;
      //dispatch(productActions.getProductsGeneric(query));
      dispatch(
        devicesListActions.initGetDevicesList({
          id,
          queryParams: query,
        })
      );
    }
  }, [query, router, logged, getMyProductFailure]);

  let breadcrumbs =
    breadcrumbForced !== undefined ? breadcrumbForced : breadcrumbsProps;

  return (
    <>
      <MetaData seoInfo={seoInfo} breadcrumbs={breadcrumbs} />
      <Header {...breadcrumbs} {...headerPropsState} />
      <main>
        {hasToShowR2RRenovationOffers && (
          <div className="container renew-r2r-campaing-title">
            <TextInfo
              text="Renueva el dispositivo de tu pack desde 0€"
              kind={TEXT_KIND.HEADING}
              level={TEXT_HEADING_LEVEL.H2}
              size={TEXT_SIZE.T4}
              color={TEXT_COLOR.MOVISTAR_BLACK}
              fontType={TEXT_FONT_WEIGHT.BOLD}
            />
          </div>
        )}
        {orionInfo && orionInfo["cms-ml-page-intro"] && (
          <CmsBlock
            alias={orionAlias}
            orionInfo={orionInfo}
            blockName="cms-ml-page-intro"
            Component={CmsPageIntro}
          />
        )}
        {bannerInfo && (
          <NeonBanner {...bannerInfo} />
        )}
        {superBannerInfo && (
          <SuperBanner {...superBannerInfo} />
        )}
        {superCategories && (
          <SuperCategoryRail id={id} items={superCategories} />
        )}
        <Devices hash={hash} id={id} orionInfo={orionInfo} orionAlias={orionAlias} />
        <BottomSEO orionInfo={orionInfo} orionAlias={orionAlias} />
      </main>
      <Footer footerProps={footerProps} />
    </>
  );
};

export const getStaticProps = wrapper.getStaticProps(async (data) => {
  const { store } = data;
  const contextData = store.getState().main.context;
  const context = {
    environment: findOutEnvByEnvName(process.env.NEXT_PUBLIC_ENV_NAME),
  };
  global.PIC_HASH = `${getTimehash()}`;
  const hash = getTimehash(36, true, true);
  global.timeHash = hash;

  let errorMsg = "";

  const { id } = data.params;
  const [custoStandardHeaders, catalogueHeaders, backendSsrHeaders] =
    await Promise.all([
      getBuildCachedJwtCloudRun("custo-standard"),
      getBuildCachedJwtCloudRun("catalogue"),
      getBuildCachedJwtCloudRun("ssr-backend"),
    ]);

  const build = true;
  let breadcrumbText;
  let categoryPageData;
  let superCategories;

  let pagePropsInfo = null;
  let custoUrlManager = null;
  let custoStampsManager = null;
  let bannerInfo = null;
  let superBannerInfo = null;
  let astroCategoryLabels;
  let aliasOrion = `cms-page-dispos-${id}`;
  const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
  const revalidate = currentEnv === "qa_ssr" ? 2 : 300;

  [pagePropsInfo, custoUrlManager, custoStampsManager, astroCategoryLabels/*bannerInfo, superBannerInfo*/] = await Promise.allSettled([
    getPageProps({
      context,
      hash,
      build: true,
      seoLocation: `/${id}`,
      footerLocation: `/${id}`,
      headerLocation: `/moviles`,
      ssrHeaders: backendSsrHeaders,
      orionCmsAlias: aliasOrion,
      cms: currentEnv === 'qa_ssr',
    }),
    getBuildCachedPromise(
      "custo:creativity:DISPOSITIVOS-URL-MANAGER",
      () => getByName({
        name: "DISPOSITIVOS-URL-MANAGER",
        build,
        kind: "creativity",
        context: contextData,
        ssrHeaders: custoStandardHeaders,
      }),
    ),
    getBuildCachedPromise(
      "custo:creativity:DISPOSITIVOS-STAMPS-MANAGER",
      () => getByName({
        name: "DISPOSITIVOS-STAMPS-MANAGER",
        build: true,
        kind: "creativity",
        context,
        ssrHeaders: custoStandardHeaders,
      }),
    ),
    loadCategoryLinkLabels({
      id,
      cms: currentEnv === "qa_ssr",
      fetchContent: apiFetch,
    }),
    /*getByName({
      name: "CMS-GP-BF-BANNER-SUPERIOR-CONTADOR",
      build: true,
      kind: "creativity",
      context,
      ssrHeaders: custoStandardHeaders,
    }),
    getByName({
      name: "CMS-GP-BF-BANNER-SUPERIOR-CATALOGO",
      build: true,
      kind: "creativity",
      context,
      ssrHeaders: custoStandardHeaders,
    }),*/
    store.dispatch(
      devicesListActions.initGetDevicesList({
        build,
        id,
        catalogueHeaders,
      })
    )
  ]);

  //CUSTOMIZER PAGES MANAGER

  if (custoUrlManager.status === 'rejected') {
    console.warn(`Error en la llamada a la creatividad del url manager: ${id} error:
      ${JSON.stringify(custoUrlManager.reason)}`);
    //Bloqueo para evitar que se revalide y salgan listados sin categorizar correctamente
    if (currentEnv === "prod") {
      throw e;
    }
  }

  if (custoStampsManager.status === 'rejected') {
    console.warn(`Error en la llamada a la creatividad de los sellos de custo: ${id} error:
      ${JSON.stringify(custoStampsManager.reason)}`
    );
    //Bloqueo para evitar que se revalide y salgan listados sin categorizar correctamente
    if (currentEnv === "prod") {
      throw e;
    }
  }

  custoUrlManager = custoUrlManager.value;
  custoStampsManager = custoStampsManager.value;

  if (custoUrlManager) {
    if (custoUrlManager.superCategories) {
      superCategories = custoUrlManager.superCategories;
    }
    if (custoUrlManager.paths) {
      if (!custoUrlManager.paths[id]) {
        return {
          notFound: true,
          revalidate
        }
      }
      categoryPageData = {
        ...custoUrlManager.paths[id],
        stamps: custoStampsManager?.stamps
      };
    }
  }

  /*if (bannerInfo.status === 'rejected') {
    errorMsg =
      `Error en la llamada a la creatividad del bannerInfo neon: ${id
      } error:${JSON.stringify(bannerInfo.reason)}`
      ;
  } else if (bannerInfo.value) {
    bannerInfo = bannerInfo.value;
  }

  if (superBannerInfo.status === 'rejected') {
    errorMsg =
      `Error en la llamada a la creatividad del superBanner: ${id
      } error:${JSON.stringify(superBannerInfo.reason)}`
      ;
  } else if (superBannerInfo.value) {
    superBannerInfo = superBannerInfo.value;
  }*/

  if (categoryPageData) {
    store.dispatch(
      pageInfoActions.getCategoryPageDataSuccess(categoryPageData)
    );
    ({ breadcrumbText } = categoryPageData);
  }

  // PAGE PROPS
  let seoInfo = "";
  let headerProps1 = null;
  let footerProps = null;
  let headerProps = null;
  let breadcrumbsProps = null;
  let orionInfo = null;

  if (pagePropsInfo.status === 'rejected') {
    const reason = pagePropsInfo.reason;
    errorMsg = `Ha ocurrido un error en la llamada al getPageProps: ${id
      } (HTTP ${reason?.statusCode ?? reason?.status ?? "desconocido"}, código ${reason?.code ?? reason?.name ?? "desconocido"})`;
    console.error(errorMsg);
    throw new Error(errorMsg);
  }

  pagePropsInfo = pagePropsInfo.value;

  if (pagePropsInfo) {
    try {
      const { header, footer, seo, orion } = pagePropsInfo;

      seoInfo = seo || null;
      headerProps1 = header || null;
      footerProps = footer || null;
      orionInfo = orion || null;

      if (seo && seo.status && seo.status === 500) {
        errorMsg = `NO SE ENCONTRÓ INFO DE SEO PARA /${id}`;
      }

      if (footer && footer.status && footer.status === 500) {
        errorMsg = `NO SE ENCONTRÓ INFO DE FOOTER PARA /${id}`;
      }

      if (orion && orion.status && orion.status === 500) {
        errorMsg = `No se ha podido recuperar información de Orion para /${id}`;
      }

    } catch (error) {
      console.log("Ha ocurrido un error al extraer getPageProps: ", error);
      console.error(error);
      errorMsg = error;
    }

  }

  if (errorMsg) {
    console.error(errorMsg);
  }

  if (headerProps1) {
    ({ headerProps, breadcrumbsProps } = headerProps1);
  }

  if (astroCategoryLabels?.status === "fulfilled") {
    orionInfo = mergeCategoryLinkLabels(orionInfo, astroCategoryLabels.value);
  }
  orionInfo = normalizeRichTextLinks(orionInfo);

  if (breadcrumbsProps) {
    breadcrumbsProps = getDevicesListBreadcrumbsProps({
      id,
      breadcrumbText,
    });
  }

  store.dispatch(headerActions.setupHeaderProps(headerProps));
  store.dispatch(END);
  await store.sagaTask.toPromise();

  // Devuelve los datos como props para la página
  return {
    props: {
      hash,
      seoInfo,
      headerProps,
      breadcrumbsProps,
      bannerInfo,
      superBannerInfo,
      id,
      orionInfo,
      footerProps,
      orionAlias: aliasOrion,
      superCategories,
    },
    revalidate,
  };
});

export const getStaticPaths = async () => {
  try {
    const context = {
      environment: findOutEnvByEnvName(process.env.NEXT_PUBLIC_ENV_NAME),
    };
    const Urlfilters = "pageIndex=0&pageSize=1&sort=relevance&minStock=0";
    const offerCategory = "FUSION_AV";
    const offerCategory2 = "PARTICULARES";
    const build = true;
    const idFront = "VT";
    const onSuccess = (response) => {
      return response;
    };
    const [catalogueHeaders, custoStandardHeaders] = await Promise.all([
      getBuildCachedJwtCloudRun("catalogue"),
      getBuildCachedJwtCloudRun("custo-standard"),
    ]);
    const items = await getAllItem({
      context,
      Urlfilters,
      offerCategory,
      offerCategory2,
      build,
      idFront,
      onSuccess,
      ssrHeaders: catalogueHeaders,
    });
    const custoUrlManager = await getBuildCachedPromise(
      "custo:creativity:DISPOSITIVOS-URL-MANAGER",
      () => getByName({
        name: "DISPOSITIVOS-URL-MANAGER",
        build,
        kind: "creativity",
        context,
        ssrHeaders: custoStandardHeaders,
      }),
    );

    const paths = [];

    let filters = items.data.filters.filter((item) => item.id === "category");

    filters.forEach((filteredItem) => {
      const { values } = filteredItem;
      if (values && Array.isArray(values)) {
        values.forEach((valueItem) => {
          if (valueItem && valueItem.path) {
            const id = valueItem.path.replace("/", "");
            if (id) {
              paths.push({
                params: { id },
              });
            }
          }
        });
      }
    });

    Object.keys(custoUrlManager.paths).forEach((pathId) =>
      paths.push({
        params: { id: pathId },
      })
    );

    return {
      paths,
      fallback: "blocking",
    };
  } catch (error) {
    console.error(
      `Error al obtener datos para generar rutas del listado: ${error}`
    );
    return {
      paths: [],
      fallback: false,
    };
  }
};

export default Dispositivos;
